import logsPageDirective from './LogsPageDirective';
import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import angularGettext from 'angular-gettext';


let logsModule = angular.module('cms.pages.logs', [
    uiRouter,
    logsPageDirective,
    angularGettext
])
    .config(routeConfig);

function routeConfig($stateProvider,gettext) {
    /** @ngInject */

    $stateProvider
        .state('logs', {
            url: '/logs?ownerName&page&order_by&order_direction&ip&context&event&createdAtAfter&createdAtBefore',
            reloadOnSearch: false,
            component: 'appLogs',
            title: gettext('Logs'),
            data: {
                requiresAuth: ['ROLE_ADMIN']
            },
            sidebarMeta: {
                icon: 'ion-clock',
                order: 1,
                allow: ['ROLE_ADMIN']
            },
        });
}

export default logsModule.name;


// WEBPACK FOOTER //
// ./src/cmsPages/Logs/Logs.js